import { useSelector } from 'react-redux'
import type { RootState } from '../providers/AppProviders'

/**
 * Always select granularly. cinnamon's Default.tsx does
 * `useAppSelector((state) => state)` and re-resolves its whole prop tree on
 * every dispatch — that is the bug we are not reproducing.
 */
export const useAppSelector = useSelector.withTypes<RootState>()
